import { useState } from 'react';
import styled from 'styled-components';

export const NumberKeyboard = ({
  handleKeyPress,
  handleDelete,
  handleReset,
}: {
  handleKeyPress: (value: string) => void;
  handleDelete: () => void;
  handleReset?: () => void;
}) => {
  return (
    <KeysContainer>
      {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
        <KeyButton key={num} onClick={() => handleKeyPress(num.toString())}>
          <KeyButtonText>{num}</KeyButtonText>
        </KeyButton>
      ))}
      {handleReset ? (
        <KeyButton onClick={handleReset}>
          <KeyButtonTextSmall>{'되돌리기'}</KeyButtonTextSmall>
        </KeyButton>
      ) : (
        <div />
      )}

      <KeyButton onClick={() => handleKeyPress('0')}>
        <KeyButtonText>{'0'}</KeyButtonText>
      </KeyButton>
      <KeyButton onClick={handleDelete}>
        <KeyButtonText>{'←'}</KeyButtonText>
      </KeyButton>
    </KeysContainer>
  );
};

const KeysContainer = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(3, 1fr);
`;

const KeyButton = styled.button`
  display: flex;
  padding: 16px 10px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
  align-self: stretch;
  cursor: pointer;
  border-radius: var(--radius-medium, 8px);
  transition: background-color 0.2s;
  &:active {
    background: var(--Light-Scheme-Monochrome-grey20, #ececf3);
  }
`;

const KeyButtonText = styled.span`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* System/XX-Large/xxl-regular */
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 85%; /* 17px */
`;

const KeyButtonTextSmall = styled.span`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* System/Small/s-medium */
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 10.2px */
`;
